import { IFilterCopy } from '~types/search'

import { Select } from 'antd'
import styled from 'styled-components'
import getRetailerSorts from '../useCases/getRetailerSorts'

export const FilterSelectSortDesktopStyles = styled(Select)`
  &.ant-select {
    min-width: 222px;
    height: 40px;
    border-radius: var(--spacing-borderRadius-medium);
    font-size: var(--typography-size-s2);
  }
  &.ant-select.ant-select-single .ant-select-selector {
    height: 100% !important;
    box-shadow: none !important;
  }
  &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 0;
  }
  &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    padding: 0 var(--spacing-padding-xlarge);
    height: 40px !important;
    border: 1.5px solid #dedede;
  }
  .arrow-icon {
    transform: rotate(90deg);
    color: #616161;
  }
`

const SortSelector = ({
  copy,
  sortOptionsConfig,
  defaultValue,
  onChangeToSort,
}: {
  copy: IFilterCopy
  sortOptionsConfig: string[]
  onChangeToSort: (value: string) => Promise<void>
  defaultValue: string
}) => {
  const options = getRetailerSorts({
    copy,
    sortOptionsConfig,
  })

  const handleChange = async (value: any) => {
    await onChangeToSort(value)
  }

  return (
    <FilterSelectSortDesktopStyles
      value={defaultValue || undefined}
      style={{ width: '100%' }}
      onChange={handleChange}
      options={options}
      placeholder={copy?.orderBy}
    />
  )
}

export default SortSelector
